import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { urls } from 'Constants/Urls'

export const rbidosCommonApi = {
	infotecsLogin: async (data: Record<string, string>) => {
		const res = await axiosDS().post<{ result: string }>(urls.rbidos_access.infotecsLogin, { data })
		return res.data
	},
	deleteInfotecsLogin: async () => {
		const res = await axiosDS().delete<SimpleResponse>(urls.rbidos_access.infotecsLogin)
		return res.data
	},
}
